

import axios from "axios";
import {
  GETSUBSECTION,
  baseURL,
} from "./type";

export const getsubsection = (data = {}) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupSubsection/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: {
      section_id: 22,   // <-- this goes in body
    
    },
  };

  axios(config)
    .then((response) => {
      dispatch({
        type: GETSUBSECTION,
        payload: response.data,
      });
    })
    .catch((error) => {
      console.log(error);
    });
};
